import React, { useEffect, useState } from "react";
import { CommonService } from "../../services/CommonService";
import { useLocalStorage } from "../../auth/useLocalStorage";
import { TableContainer, Paper, Button, IconButton, Typography, Table, TableHead, TableBody, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { mappingOperations, EMapStatusSale, ISale, IDetails, ISaleDetail } from "../../common/interfaces";
import VisibilityIcon from '@mui/icons-material/Visibility';
export const ScheduleOrders: React.FC = () => {
  const [user, ] = useLocalStorage("user", null);
  const [rows, setRows] = useState([])
  const [view, setView] = useState('list')
  const [sale, setSale] = useState<ISale>()
  const [selectedSale, setSelectedSale] = useState(0)
  const warehouseId = user?.warehouse_id

  const mapPaymentsMethods = {
    cash: "Efectivo",
    credit_card: "Tarjeta de Crédito",
    debit_card: "Tarjeta de Débito",
    gift_card: "Tarjeta de Regalo",
    vales: "Vales de despensa",
    usd: "Dólares",
    other: "Otros",
    transfer: "Transferencia",
    credit: "Crédito",
  };

  const shippedTypeMap: Record<string, string> = {
    shipped: "A Domicilio",
    onSite: "Recoger en Tienda",
    inRoom: "Comedor",
  };

  // Función para calcular la hora de envío (hora de entrega - 30 minutos)
  // Solo aplica para pedidos a domicilio
  const calculateSendTime = (deliveryTime: string, shippedType: string) => {
    if (shippedType === 'shipped') {
      return moment(deliveryTime).subtract(30, 'minutes').format("hh:mm a");
    }
    return '-';
  };

  // Función para calcular el total de anticipos
  const calculateTotalAnticipos = (payments: any[]) => {
    if (!payments || payments.length === 0) return 0;
    return payments.reduce((acc, payment) => acc + parseFloat(String(payment.amount || "0")), 0);
  };

  useEffect(() => {
    CommonService.getScheduleOrders(warehouseId).then((response: any) => {
      console.log("Schedule Orders", response)
      if(response.success){
        setRows(response.object)
      }
    })
  }, [])
  useEffect(() => {
    if(view === 'detail'){
      if(selectedSale > 0){
        CommonService.getSaleInfo(selectedSale).then((response: any) => {
          console.log("Ticket Order Information", response)
          if(response.success){
            setSale(response.object)
          }
        })
      }
    }
  }, [view])
  const viewItem = (item: any) => {
    setSelectedSale(item.order.id)
    setView('detail')
  }
  return (
    <div>
      {
        view === 'list' && (
          <TableContainer component={Paper}>
            <table
              style={{
                width: "100%",
                fontSize: "14px",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "7%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    ID Venta
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Fecha de Registro
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Usuario
                  </th>
                  <th
                    style={{ width: "12%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Cliente
                  </th>
                  <th
                    style={{ width: "9%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Tel.
                  </th>
                  <th
                    style={{ width: "7%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Anticipo
                  </th>
                  <th
                    style={{ width: "7%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Monto
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Fecha de Entrega
                  </th>
                  <th
                    style={{ width: "10%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Entrega
                  </th>
                  <th
                    style={{ width: "9%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Hora de Envío
                  </th>
                  <th
                    style={{ width: "9%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                    Hora de Entrega
                  </th>
                  <th
                    style={{ width: "5%", borderBottom: "1px solid #ccc" }}
                    align="center"
                  >
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row: any) => {
                  const totalAnticipos = calculateTotalAnticipos(row.order?.payments);
                  console.log('Row data:', {
                    orderId: row.order?.id,
                    payments: row.order?.payments,
                    totalAnticipos
                  });

                  return row.order ? (
                    <tr key={row.id}>
                      <td align="center">{row.order.id ? `S-${row.order.id}` : ''}</td>
                      <td align="center">{moment(row.order.created_at).format("DD/MM/YYYY HH:mm")}</td>
                      <td align="center">{row.order.usuario?.nombre || '-'}</td>
                      <td align="center">{row.order.cliente.nombre}</td>
                      <td align="center">{row.order.cliente?.telefono}</td>
                      <td align="center">{totalAnticipos > 0 ? totalAnticipos.toFixed(2) : '0.00'}</td>
                      <td align="center">{row.order.total}</td>
                      <td align="center">{moment(row.schedule_data).format("DD/MM/YYYY")}</td>
                      <td align="center">{shippedTypeMap[row.order.shipped_type] || row.order.shipped_type || '-'}</td>
                      <td align="center">{calculateSendTime(row.schedule_data, row.order.shipped_type)}</td>
                      <td align="center">{moment(row.schedule_data).format("hh:mm a")}</td>
                      <td align="center">
                        <IconButton
                          aria-label="delete"
                          onClick={() => viewItem(row)}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </td>
                    </tr>
                  ) : null;
                })}
                {/* {rows.map((row: any) => (
                  <tr key={row.id}>
                    <td align="center">{row.id}</td>
                    <td align="center">{row.client_name}</td>
                    <td align="center">{row.total_amount}</td>
                    <td align="center">{moment(row.date).format("DD/MM/YYYY")}</td>
                    <td align="center">{moment(row.date).format("HH:mm")}</td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </TableContainer>
        )
      }
      {
        view === 'detail' && (
          <div>
            <Typography style={{ fontSize: "18px" }}>Pedido: { sale?.id }</Typography>
            <Typography style={{ fontSize: "18px" }}>Cliente: { sale?.cliente?.nombre }</Typography>
            <Typography style={{ fontSize: "18px" }}>Teléfono: { sale?.cliente?.telefono }</Typography>
            <Typography style={{ fontSize: "18px" }}>Monto: $ { sale?.total }</Typography>
            <Typography style={{ fontSize: "18px" }}>Fecha y Hora de Registro: { moment(sale?.created_at).format("DD/MM/YYYY  HH:mm a") }</Typography>
            <Typography style={{ fontSize: "18px" }}>Fecha y Hora de Entrega: { moment(sale?.schedule).format("DD/MM/YYYY HH:mm a") }</Typography>
            <br />

            {/* Sección para mostrar anticipos */}
            <div>
              <Typography variant="h6">Anticipos:</Typography>
              {sale?.payments && sale.payments.length > 0 ? (
                <TableContainer component={Paper} style={{ maxHeight: "200px", overflowY: "auto" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha y Hora</TableCell>
                        <TableCell>Método de Pago</TableCell>
                        <TableCell>Monto</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sale.payments.map((payment, index) => (
                        <TableRow key={index}>
                          <TableCell>{moment(payment.created_at).format("DD/MM/YYYY h:mm A")}</TableCell>
                          <TableCell>{mapPaymentsMethods[payment.payment_method]}</TableCell>
                          <TableCell>$ {payment.amount}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <tfoot>
                      <TableRow>
                        <TableCell colSpan={2} style={{ textAlign: "right", fontWeight: "bold" }}>
                          Total de Anticipos:
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          $ {sale.payments.reduce((acc, payment) => acc + parseFloat(String(payment.amount || "0")), 0).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    </tfoot>
                  </Table>
                </TableContainer>
              ) : (
                <Typography>No hay anticipos registrados.</Typography>
              )}
            </div>

            <br />

            <Typography style={{ fontSize: "18px" }}>Detalles de Productos:</Typography>
            <TableContainer component={Paper}>
            <table style={{
                width: "100%",
                fontSize: "14px",
                borderCollapse: "collapse",
              }}>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Precio</th>
                  <th>Iva</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                { sale?.detalles.map((detail: ISaleDetail) => (
                  <tr key={detail.id}>
                    <td>{ detail.producto.name }</td>
                    <td>{ detail.cantidad }</td>
                    <td>{ detail.precio }</td>
                    <td>{ detail.iva }</td>
                    <td>{ detail.total }</td>

                  </tr>
                )) }
                </tbody>
            </table>
            </TableContainer>
            <br />
            <br />
            <Button onClick={() => setView('list')}>Volver</Button>
          </div>
        )
      }
    </div>
  );
}